import { useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'
import { CurrencySelectorCurrencyFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import BasicInformation from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation'
import DocumentNumberField from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/BasicInformation/DocumentNumberField'
import Taxes from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Taxes'
import Vendor from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Vendor'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  currencies?: CurrencySelectorCurrencyFragment[]
  onDocumentTypeChange: (value: string) => void
  onEffectiveOnChange: (value: string) => void
  isAutomaticExpensable: boolean
}

const DocumentInformation = (props: Props) => {
  // TODO: @luchhh remove this, document type is not really needed by document number field

  const { watch } = useFormContext()
  const documentType = watch('documentType')

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.document_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.document_information_subtitle')}
    >
      <Box gap="s24">
        <BasicInformation {...props} />
        <Taxes {...props} fieldIdentifier="taxes" />
        <DocumentNumberField
          {...props}
          fieldIdentifier="document_number"
          documentType={documentType}
        />
        <Vendor {...props} documentType={documentType} />
      </Box>
    </FormBlock>
  )
}

export default DocumentInformation
